@if (!isMobile()) {
  <!-- Desktop: horizontal tabs -->
  <div class="tabs">
    <div class="tabs__bar" role="tablist">
      @for (tab of availableTabs(); track tab.id) {
        <button
          class="tabs__tab"
          [class.tabs__tab--active]="activeTab() === tab.id"
          role="tab"
          [attr.aria-selected]="activeTab() === tab.id"
          [attr.aria-controls]="'panel-' + tab.id"
          (click)="setTab(tab.id)"
        >
          {{ tab.label }}
        </button>
      }
    </div>

    <div class="tabs__panel" role="tabpanel" [attr.id]="'panel-' + activeTab()">
      <ng-container *ngTemplateOutlet="tabContent" />
    </div>
  </div>
} @else {
  <!-- Mobile: accordion -->
  <div class="accordion">
    @for (tab of availableTabs(); track tab.id) {
      <div class="accordion__item">
        <button
          class="accordion__header"
          [class.accordion__header--open]="isAccordionOpen(tab.id)"
          (click)="toggleAccordion(tab.id)"
          [attr.aria-expanded]="isAccordionOpen(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <app-icon
            class="accordion__chevron"
            [class.accordion__chevron--open]="isAccordionOpen(tab.id)"
            [icon]="chevronDown"
            [size]="18"
          />
        </button>
        @if (isAccordionOpen(tab.id)) {
          <div class="accordion__body">
            @switch (tab.id) {
              @case ('description') {
                <ng-container [ngTemplateOutlet]="descriptionTpl" />
              }
              @case ('specs') {
                <ng-container [ngTemplateOutlet]="specsTpl" />
              }
              @case ('articles') {
                <ng-container [ngTemplateOutlet]="articlesTpl" />
              }
            }
          </div>
        }
      </div>
    }
  </div>
}

<!-- Shared tab content (desktop) -->
<ng-template #tabContent>
  @switch (activeTab()) {
    @case ('description') {
      <ng-container [ngTemplateOutlet]="descriptionTpl" />
    }
    @case ('specs') {
      <ng-container [ngTemplateOutlet]="specsTpl" />
    }
    @case ('articles') {
      <ng-container [ngTemplateOutlet]="articlesTpl" />
    }
  }
</ng-template>

<!-- ── Description template ──────────────────────────────── -->
<ng-template #descriptionTpl>
  <div class="tab-content">
    @if (isSingle()) {
      @if (product().cardText) {
        <div class="tab-content__card-text">
          <h4 class="tab-content__subtitle">Texto de la carta</h4>
          <p class="tab-content__oracle">{{ product().cardText }}</p>
        </div>
      }
      @if (product().description) {
        <div class="tab-content__lore">
          <h4 class="tab-content__subtitle">Acerca de esta carta</h4>
          <div class="tab-content__rich" [innerHTML]="product().description"></div>
        </div>
      }
      @if (product().artist) {
        <p class="tab-content__artist">
          <span class="tab-content__label">Artista:</span> {{ product().artist }}
        </p>
      }
    } @else if (isSealed()) {
      @if (product().contents) {
        <div>
          <h4 class="tab-content__subtitle">Contenido del producto</h4>
          <p>{{ product().contents }}</p>
        </div>
      }
      @if (product().releaseDate) {
        <p class="tab-content__meta">
          <span class="tab-content__label">Fecha de lanzamiento:</span> {{ product().releaseDate }}
        </p>
      }
      @if (product().description) {
        <div class="tab-content__rich" [innerHTML]="product().description"></div>
      }
    } @else {
      <!-- Accessory / other -->
      @if (product().description) {
        <div class="tab-content__rich" [innerHTML]="product().description"></div>
      }
      @if (product().brand) {
        <p class="tab-content__meta">
          <span class="tab-content__label">Marca:</span> {{ product().brand }}
        </p>
      }
    }
  </div>
</ng-template>

<!-- ── Specs template (accessory only) ───────────────────── -->
<ng-template #specsTpl>
  <div class="tab-content">
    <table class="specs-table">
      <tbody>
        @for (entry of specEntries(); track entry[0]) {
          <tr class="specs-table__row">
            <th class="specs-table__label">{{ entry[0] }}</th>
            <td class="specs-table__value">{{ entry[1] }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</ng-template>

<!-- ── Articles template ─────────────────────────────────── -->
<ng-template #articlesTpl>
  <div class="tab-content">
    <div class="articles-grid">
      @for (article of articles(); track article.id) {
        <a class="article-card" [href]="'/blog/' + article.slug">
          <img
            class="article-card__image"
            [src]="article.imageUrl"
            [alt]="article.title"
            loading="lazy"
          />
          <div class="article-card__body">
            <h4 class="article-card__title">{{ article.title }}</h4>
            <p class="article-card__excerpt">{{ article.excerpt }}</p>
            <time class="article-card__date">{{ article.date }}</time>
          </div>
        </a>
      }
    </div>
  </div>
</ng-template>
